namespace advisorop.domains {

    export interface IBillScheduleFullDto {
        howBilled?: number;
        scheduleCode?: string;
        linearBreakpointMaximums?: boolean;
        aggregateByHousehold?: boolean;
        statementDeliveryMethods?: IBillScheduleStatementDeliveryMethodDto[];
        details?: IBillScheduleDetailDto[];
        id?: number;
        name?: string;
        description?: string;
        schedule?: BillScheduleSchedule;
        entity?: BillScheduleEntity;
        type?: string;
        basis?: BillScheduleBasis;
        minFeeAcctValueThreshold?: number;
        minimumFee?: number;
        billEntityId?: number;
        billEntityDescription?: string;
        showInFeeCalculator?: boolean;
        isActive?: boolean;
        isPayoutCreditOffset?: boolean;
        createdDate?: Date;
        createdBy?: string;
        editedDate?: Date;
        editedBy?: string;
        useStatementDeliveryMethod?: boolean;
    }

    export interface IBillScheduleStatementDeliveryMethodDto {
        id?: number;
        name?: string;
    }

    export interface IBillScheduleDetailDto {
        id?: number;
        minimumAmount?: number;
        maximumAmount?: number;
        rate?: number;
        minimum?: number;
        maximum?: number;
        flatFee?: number;
        points?: number;
    }

    export interface IAccountFeeModelDto {
        feeScheduleId?: number;
        feeSchedule?: string;
        modelAggId?: number;
        id?: number;               // AccountId
        name?: string;             // AccountName
        number?: string;           // AccountNumber
        modelName?: string;
        currentValue?: number;
        accountType?: string;
    }

    export enum BillScheduleSchedule {
        Monthly = "Monthly",
        Quarterly = "Quarterly",
        SemiAnnually = "SemiAnnually",
        Annually = "Annually"
    }

    export enum BillScheduleEntity {
        Account = "Account",
        Household = "Household"
    }

    export enum BillScheduleBasis {
        MarketValue = "MarketValue",
        ManagedValue = "ManagedValue",
        CashValue = "CashValue"
    }
}
